import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  SideNavMobile,
  SideNavSearch,
  SideNavDropdownMenu,
  SideNavMenuItem,
  SideNavTitle,
} from '@lanl-web/lanl-components';
import './LocalNavMobile.scss';

export const LocalNavMobile = ({ location, menuItems }) => {
  const [showMenu, setShowMenu] = useState(false);

  const search = (e) => {
    const { target, key } = e;

    if (target.value && key === 'Enter') {
      window.location.replace(
        `https://searcher-green.lanl.gov/webapps/LANL_External#/search?q=${encodeURI(
          e.target.value,
        )}`,
      );
    }
  };

  return (
    <SideNavMobile
      location={location}
      setShowMenu={setShowMenu}
      showMenu={showMenu}
      className='local-nav-mobile'
      homeName='Research Library'
    >
      <SideNavSearch setShowMenu={setShowMenu} handleFilter={search} />
      {menuItems.map(({ name, slug, page }, index) => {
        if (index === 0) {
          return (
            <SideNavTitle link='/' active={true} key='sidenav-dropdown-title'>
              {name}
            </SideNavTitle>
          );
        } else {
          return (
            <SideNavDropdownMenu
              title={name}
              key={`sidenav-dropdown-menu-${index}`}
            >
              <SideNavMenuItem
                key={`sidenav-menu-item-page-${index}`}
                link={`/${slug}/`}
              >
                {name}
              </SideNavMenuItem>
              {page.map(({ slug: pageSlug, title }, index) => (
                <SideNavMenuItem
                  key={`sidenav-menu-item-page-${index}`}
                  link={`/${slug}/${pageSlug}`}
                >
                  {title}
                </SideNavMenuItem>
              ))}
            </SideNavDropdownMenu>
          );
        }
      })}
    </SideNavMobile>
  );
};

LocalNavMobile.propTypes = {
  location: PropTypes.object,
  menuItems: PropTypes.array,
};

export default LocalNavMobile;
